import moment from 'moment';

const hasExpired = (date, allowedDurationInMinutes) => {
  if (date == null) {
    return true;
  }
  const now = moment();
  const minutesElapsed = now.diff(moment(date), 'minutes');
  return minutesElapsed >= allowedDurationInMinutes;
};

const cacheDurationInMinutes = 5;

class PageActions {
  /**
   *
   * @type {[PageElement]}
   */
  actions = [];

  lastUpdated = null;

  isLoading = false;

  actionsMap = {};

  constructor(actions = []) {
    this.actions = actions || [];
    this.actionsMap = this.actions.reduce((acc, action) => {
      acc[action.pageElementId] = true;
      return acc;
    }, {});
  }

  /**
   *
   * @param action{PageElement}
   * @returns {PageActions}
   */
  addAction(action) {
    if (!(action.pageElementId in this.actionsMap)) {
      this.actions.push(action);
      this.actionsMap[action.pageElementId] = true;
    }

    this.setLastUpdated();
    return this;
  }

  setActions(actions) {
    this.actions = [];
    this.actionsMap = {};
    actions.reduce((acc, value) => acc.addAction(value), this);
    this.setLastUpdated();
    this.isLoading = false;
    return this;
  }

  clear() {
    this.actions = [];
    this.actionsMap = {};
    this.lastUpdated = null;
    return this;
  }

  setLastUpdated() {
    this.lastUpdated = new Date();
    return this;
  }

  needsData() {
    if (this.isLoading) {
      return false;
    }

    return hasExpired(this.lastUpdated, cacheDurationInMinutes);
  }
}

export default PageActions;
